import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-invited-members',
  templateUrl: './invited-members.component.html',
  styleUrls: ['./invited-members.component.css']
})
export class InvitedMembersComponent implements OnInit {

  @Input() NoOfInvitedMembers: number;;
  @Input() active: boolean;
  @Output() filterProgramsEvent = new EventEmitter();
  program_status = '';

  constructor() { }

  ngOnInit() {
  }

  filterMemberListing(value) {
    this.program_status = value;
    this.filterProgramsEvent.emit(this.program_status);
  }
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/invited-members/invited-members.component.ts